import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "panel-title mb-0" }
const _hoisted_6 = { class: "row mb-4" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "card bg-dark text-light" }
const _hoisted_9 = { class: "card-body text-center" }
const _hoisted_10 = { class: "text-primary" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "card bg-dark text-light" }
const _hoisted_14 = { class: "card-body text-center" }
const _hoisted_15 = { class: "text-success" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "card bg-dark text-light" }
const _hoisted_19 = { class: "card-body text-center" }
const _hoisted_20 = { class: "text-warning" }
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "card bg-dark text-light" }
const _hoisted_24 = { class: "card-body text-center" }
const _hoisted_25 = { class: "text-danger" }
const _hoisted_26 = { class: "mb-0" }
const _hoisted_27 = { class: "card bg-dark text-light" }
const _hoisted_28 = { class: "card-header" }
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = { class: "table-responsive" }
const _hoisted_32 = { class: "table table-dark table-striped" }
const _hoisted_33 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_34 = { class: "endpoints-list" }
const _hoisted_35 = {
  key: 0,
  class: "badge bg-secondary"
}
const _hoisted_36 = { class: "permissions-list" }
const _hoisted_37 = {
  key: 0,
  class: "badge bg-success me-1"
}
const _hoisted_38 = {
  key: 1,
  class: "badge bg-warning me-1"
}
const _hoisted_39 = {
  key: 2,
  class: "badge bg-danger me-1"
}
const _hoisted_40 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_41 = ["onClick", "disabled", "title"]
const _hoisted_42 = ["onClick", "disabled"]
const _hoisted_43 = ["onClick", "disabled"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "custom-modal-header" }
const _hoisted_46 = { class: "custom-modal-title" }
const _hoisted_47 = { class: "custom-modal-body" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-6 mb-3" }
const _hoisted_50 = { class: "form-label" }
const _hoisted_51 = ["placeholder"]
const _hoisted_52 = { class: "col-md-6 mb-3" }
const _hoisted_53 = { class: "form-label" }
const _hoisted_54 = ["placeholder"]
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-12 mb-3" }
const _hoisted_57 = { class: "form-label" }
const _hoisted_58 = { class: "endpoints-grid" }
const _hoisted_59 = ["id", "value"]
const _hoisted_60 = ["for"]
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-12 mb-3" }
const _hoisted_63 = { class: "form-label" }
const _hoisted_64 = { class: "permissions-grid" }
const _hoisted_65 = { class: "form-check" }
const _hoisted_66 = {
  for: "read-permission",
  class: "form-check-label"
}
const _hoisted_67 = { class: "form-check" }
const _hoisted_68 = {
  for: "write-permission",
  class: "form-check-label"
}
const _hoisted_69 = { class: "form-check" }
const _hoisted_70 = {
  for: "admin-permission",
  class: "form-check-label"
}
const _hoisted_71 = { class: "custom-modal-footer" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-1"
}

import {computed, getCurrentInstance, onMounted, ref} from 'vue'
import { formatIsoDate } from "@/utils/format"
import { apiGet, apiPost } from "@/services/api/client";
import BaseModal from "@/components/ui/BaseModal.vue"
import StateBlock from "@/components/ui/StateBlock.vue"
import PanelNoAccess from "@/components/panel/PanelNoAccess.vue"
import { panelRequest, isForbidden, reportPanelError } from "@/components/panel/panelAccess"
import {AccessToken, TokenPayload, TokenResponse} from "shared/Tokens";

interface Props {
  user: any
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenManagerComponent',
  props: {
    user: {}
  },
  setup(__props: any) {

const instance = getCurrentInstance()
const t = (key: string, named?: Record<string, unknown>): string => (instance!.proxy as any).$t(key, named ?? {})

// Props
const props = __props

// Reactive data
const forbidden = ref(false)
const tokens = ref<AccessToken[]>([])
const availableEndpoints = ref<string[]>([])
const showCreateModal = ref(false)
const creating = ref(false)

const newToken = ref({
  name: '',
  description: '',
  endpoints: [] as string[],
  permissions: {
    read: false,
    write: false,
    admin: false
  }
})

// Computed properties
const activeTokensCount = computed(() => {
  return tokens.value.filter(token => token.isActive && !isExpired(token)).length
})

const expiredTokensCount = computed(() => {
  return tokens.value.filter(token => isExpired(token)).length
})

const inactiveTokensCount = computed(() => {
  return tokens.value.filter(token => !token.isActive && !isExpired(token)).length
})

// Methods
const loadTokens = async () => {
  try {
    tokens.value = await apiGet('/tokens/all', panelRequest)
  } catch (error) {
    if (isForbidden(error)) forbidden.value = true
    else reportPanelError('Error loading tokens:', error)
  }
}

const loadAvailableEndpoints = async () => {
  try {
    availableEndpoints.value = await apiGet('/tokens/endpoints', panelRequest) as string[]
  } catch (error) {
    if (isForbidden(error)) forbidden.value = true
    else reportPanelError('Error loading endpoints:', error)
  }
}

const openCreateModal = () => {
  showCreateModal.value = true
}

const createToken = async () => {
  if (newToken.value.endpoints.length === 0) {
    alert(t('panel.tokens.selectEndpoint'))
    return
  }

  if (!newToken.value.permissions.read && !newToken.value.permissions.write && !newToken.value.permissions.admin) {
    alert(t('panel.tokens.selectPermission'))
    return
  }

  creating.value = true
  try {
    const response = await apiPost('/tokens/create', newToken.value) as TokenResponse
    
    // Store the JWT token for the newly created token
    const tokenInfo = response.tokenInfo
    tokenInfo.jwtToken = response.token
    
    alert(t('panel.tokens.created', { jwt: response.token, id: tokenInfo.id }))
    
    showCreateModal.value = false
    await loadTokens()
    
    // Reset form
    newToken.value = {
      name: '',
      description: '',
      endpoints: [],
      permissions: {
        read: false,
        write: false,
        admin: false
      }
    }
  } catch (error) {
    console.error('Error creating token:', error)
    alert(t('panel.tokens.createFailed'))
  } finally {
    creating.value = false
  }
}

const copyToken = async (token: any) => {
  try {
    // Get the JWT token from the backend
    const response = await apiGet(`/tokens/${token.id}/jwt`)
    const jwtToken = response.token
    
    await navigator.clipboard.writeText(jwtToken)
    alert(t('panel.tokens.copied'))
  } catch (error) {
    console.error('Error copying token:', error)
    alert(t('panel.tokens.copyFailed'))
  }
}

const deactivateToken = async (tokenId: string) => {
  if (!confirm(t('panel.tokens.confirmDeactivate'))) return
  
  try {
    await apiPost('/tokens/deactivate', { tokenId })
    await loadTokens()
  } catch (error) {
    console.error('Error deactivating token:', error)
    alert(t('panel.tokens.deactivateFailed'))
  }
}

const activateToken = async (tokenId: string) => {
  try {
    // Note: This would require a new endpoint for activating tokens
    // For now, we'll just reload the tokens
    await loadTokens()
  } catch (error) {
    console.error('Error activating token:', error)
    alert(t('panel.tokens.activateFailed'))
  }
}

const deleteToken = async (tokenId: string) => {
  if (!confirm(t('panel.tokens.confirmDelete'))) return
  
  try {
    await apiPost('/tokens/delete', { tokenId })
    await loadTokens()
  } catch (error) {
    console.error('Error deleting token:', error)
    alert(t('panel.tokens.deleteFailed'))
  }
}

const isExpired = (token: any) => {
  return new Date(token.expiresAt) < new Date()
}

const getStatusText = (token: any) => {
  if (isExpired(token)) return t('panel.tokens.statusExpired')
  if (!token.isActive) return t('panel.tokens.statusInactive')
  return t('panel.tokens.statusActive')
}

const getStatusBadgeClass = (token: any) => {
  if (isExpired(token)) return 'badge bg-secondary'
  if (!token.isActive) return 'badge bg-warning'
  return 'badge bg-success'
}

const getCopyButtonTitle = (token: any) => {
  if (isExpired(token)) return t('panel.tokens.titleExpired')
  if (!token.isActive) return t('panel.tokens.titleInactive')
  return t('panel.tokens.titleCopy')
}

// Lifecycle
onMounted(() => {
  loadTokens()
  loadAvailableEndpoints()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('panel.tokens.title')), 1),
          (!forbidden.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary",
                onClick: openCreateModal
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.tokens.createNew')), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (forbidden.value)
      ? (_openBlock(), _createBlock(PanelNoAccess, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h4", _hoisted_10, _toDisplayString(activeTokensCount.value), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('panel.tokens.active')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h4", _hoisted_15, _toDisplayString(tokens.value.length), 1),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('panel.tokens.total')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h4", _hoisted_20, _toDisplayString(expiredTokensCount.value), 1),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('panel.tokens.expired')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h4", _hoisted_25, _toDisplayString(inactiveTokensCount.value), 1),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('panel.tokens.inactive')), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("h5", _hoisted_29, _toDisplayString(_ctx.$t('panel.tokens.tableTitle')), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("table", _hoisted_32, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tokens.colName')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tokens.colEndpoints')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tokens.colPermissions')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tokens.colCreatedBy')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tokens.colCreated')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tokens.colExpires')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tokens.colStatus')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tokens.colActions')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tokens.value, (token) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: token.id
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, [
                            _createElementVNode("strong", null, _toDisplayString(token.name), 1),
                            (token.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(token.description), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_34, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(token.endpoints.slice(0, 3), (endpoint) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: endpoint,
                                class: "badge bg-info me-1"
                              }, _toDisplayString(endpoint), 1))
                            }), 128)),
                            (token.endpoints.length > 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('panel.tokens.more', { n: token.endpoints.length - 3 })), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_36, [
                            (token.permissions.read)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t('panel.tokens.read')), 1))
                              : _createCommentVNode("", true),
                            (token.permissions.write)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('panel.tokens.write')), 1))
                              : _createCommentVNode("", true),
                            (token.permissions.admin)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('panel.tokens.admin')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(token.createdBy), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(formatIsoDate)(token.createdAt)), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(formatIsoDate)(token.expiresAt)), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(getStatusBadgeClass(token))
                          }, _toDisplayString(getStatusText(token)), 3)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-secondary",
                              onClick: ($event: any) => (copyToken(token)),
                              disabled: !token.isActive || isExpired(token),
                              title: getCopyButtonTitle(token)
                            }, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("i", { class: "fa fa-copy" }, null, -1)
                            ]))], 8, _hoisted_41),
                            (token.isActive)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-sm btn-outline-secondary",
                                  onClick: ($event: any) => (deactivateToken(token.id)),
                                  disabled: !token.isActive
                                }, [...(_cache[11] || (_cache[11] = [
                                  _createElementVNode("i", { class: "fa fa-pause" }, null, -1)
                                ]))], 8, _hoisted_42))
                              : _createCommentVNode("", true),
                            (!token.isActive)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "btn btn-sm btn-outline-secondary",
                                  onClick: ($event: any) => (activateToken(token.id)),
                                  disabled: token.isActive
                                }, [...(_cache[12] || (_cache[12] = [
                                  _createElementVNode("i", { class: "fa fa-play" }, null, -1)
                                ]))], 8, _hoisted_43))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-danger",
                              onClick: ($event: any) => (deleteToken(token.id))
                            }, [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                            ]))], 8, _hoisted_44)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createVNode(BaseModal, {
            show: showCreateModal.value,
            "content-class": "token-modal-content",
            onClose: _cache[8] || (_cache[8] = ($event: any) => (showCreateModal.value = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("h5", _hoisted_46, _toDisplayString(_ctx.$t('panel.tokens.createTitle')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateModal.value = false))
                })
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("form", {
                  onSubmit: _withModifiers(createToken, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t('panel.tokens.tokenName')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newToken.value.name) = $event)),
                        type: "text",
                        class: "form-control",
                        placeholder: _ctx.$t('panel.tokens.namePlaceholder'),
                        required: ""
                      }, null, 8, _hoisted_51), [
                        [_vModelText, newToken.value.name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('panel.tokens.description')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newToken.value.description) = $event)),
                        type: "text",
                        class: "form-control",
                        placeholder: _ctx.$t('panel.tokens.descriptionPlaceholder')
                      }, null, 8, _hoisted_54), [
                        [_vModelText, newToken.value.description]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('panel.tokens.endpointsCount', { n: availableEndpoints.value.length })), 1),
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(StateBlock, {
                          loading: availableEndpoints.value.length === 0,
                          "loading-text": _ctx.$t('panel.tokens.loadingEndpoints'),
                          padding: "py-2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableEndpoints.value, (endpoint, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "form-check"
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: `endpoint-${index}`,
                                    type: "checkbox",
                                    value: endpoint,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newToken.value.endpoints) = $event)),
                                    class: "form-check-input"
                                  }, null, 8, _hoisted_59), [
                                    [_vModelCheckbox, newToken.value.endpoints]
                                  ]),
                                  _createElementVNode("label", {
                                    for: `endpoint-${index}`,
                                    class: "form-check-label"
                                  }, _toDisplayString(endpoint), 9, _hoisted_60)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }, 8, ["loading", "loading-text"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('panel.tokens.colPermissions')), 1),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _withDirectives(_createElementVNode("input", {
                            id: "read-permission",
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newToken.value.permissions.read) = $event)),
                            class: "form-check-input"
                          }, null, 512), [
                            [_vModelCheckbox, newToken.value.permissions.read]
                          ]),
                          _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t('panel.tokens.permRead')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _withDirectives(_createElementVNode("input", {
                            id: "write-permission",
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newToken.value.permissions.write) = $event)),
                            class: "form-check-input"
                          }, null, 512), [
                            [_vModelCheckbox, newToken.value.permissions.write]
                          ]),
                          _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t('panel.tokens.permWrite')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _withDirectives(_createElementVNode("input", {
                            id: "admin-permission",
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newToken.value.permissions.admin) = $event)),
                            class: "form-check-input"
                          }, null, 512), [
                            [_vModelCheckbox, newToken.value.permissions.admin]
                          ]),
                          _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('panel.tokens.permAdmin')), 1)
                        ])
                      ])
                    ])
                  ])
                ], 32)
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (showCreateModal.value = false))
                }, _toDisplayString(_ctx.$t('panel.tokens.cancel')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: createToken,
                  disabled: creating.value
                }, [
                  (creating.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_73))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.tokens.create')), 1)
                ], 8, _hoisted_72)
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ], 64))
  ]))
}
}

})